import React, { useState, useRef } from "react";
import axios from "../../axios-order";

// ─── Styles ────────────────────────────────────────────────────────────────
const css = `
  @import url('https://fonts.googleapis.com/css2?family=Libre+Baskerville:ital,wght@0,400;0,700;1,400&family=Source+Sans+3:wght@400;600;700&display=swap');

  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }

  body { background: #f0f0f0; font-family: 'Source Sans 3', Arial, sans-serif; }

  /* ── Modal overlay ── */
  .msa-overlay {
    position: fixed; inset: 0; background: rgba(0,0,0,0.55);
    display: flex; align-items: center; justify-content: center;
    z-index: 1000; padding: 20px;
  }
  .msa-modal {
    background: #fff; border-radius: 4px;
    box-shadow: 0 20px 60px rgba(0,0,0,0.35);
    width: 100%; max-width: 520px; padding: 36px 40px;
    animation: modalIn 0.2s ease;
  }
  @keyframes modalIn { from { opacity:0; transform: translateY(-12px); } to { opacity:1; transform: translateY(0); } }

  .msa-modal-logo {
    font-family: 'Libre Baskerville', serif; font-size: 13px; font-weight: 700;
    letter-spacing: 0.05em; color: #1a3a5c; margin-bottom: 20px;
    padding-bottom: 16px; border-bottom: 1px solid #e0e0e0;
  }
  .msa-modal-logo span { color: #1a3a5c; }

  .msa-modal h2 {
    font-family: 'Libre Baskerville', serif; font-size: 18px;
    color: #111; margin-bottom: 6px; font-weight: 700;
  }
  .msa-modal-sub { font-size: 13px; color: #666; margin-bottom: 24px; line-height: 1.5; }

  .msa-field { margin-bottom: 16px; }
  .msa-field label {
    display: block; font-size: 12px; font-weight: 600;
    color: #444; letter-spacing: 0.04em; text-transform: uppercase; margin-bottom: 5px;
  }
  .msa-field input {
    width: 100%; border: 1.5px solid #d0d0d0; border-radius: 3px;
    padding: 9px 12px; font-family: 'Source Sans 3', sans-serif;
    font-size: 14px; color: #111; outline: none;
    transition: border-color 0.15s;
  }
  .msa-field input:focus { border-color: #1a3a5c; }
  .msa-field input.error { border-color: #c0392b; }
  .msa-field-error { font-size: 11px; color: #c0392b; margin-top: 3px; }

  .msa-modal-actions { display: flex; gap: 10px; margin-top: 24px; }
  .msa-btn-cancel {
    flex: 1; padding: 11px; border: 1.5px solid #d0d0d0; background: #fff;
    color: #555; font-family: 'Source Sans 3', sans-serif; font-size: 14px;
    font-weight: 600; cursor: pointer; border-radius: 3px; transition: all 0.15s;
  }
  .msa-btn-cancel:hover { background: #f5f5f5; }
  .msa-btn-agree {
    flex: 2; padding: 11px; border: none; background: #1a3a5c;
    color: #fff; font-family: 'Source Sans 3', sans-serif; font-size: 14px;
    font-weight: 700; cursor: pointer; border-radius: 3px;
    transition: background 0.15s; letter-spacing: 0.02em;
  }
  .msa-btn-agree:hover { background: #0f2540; }
  .msa-btn-agree:disabled { background: #8ea5bc; cursor: not-allowed; }

  /* ── Page wrapper ── */
  .msa-page {
    min-height: 100vh; background: #e8e8e8;
    display: flex; flex-direction: column; align-items: center;
    padding: 0 0 60px;
  }

  /* ── Top bar ── */
  .msa-topbar {
    width: 100%; background: #1a3a5c; color: #fff;
    display: flex; align-items: center; justify-content: space-between;
    padding: 14px 40px; margin-bottom: 28px;
  }
  .msa-topbar-brand {
    font-family: 'Libre Baskerville', serif; font-size: 15px; font-weight: 700;
  }
  .msa-topbar-brand span { color: #fff; }
  .msa-topbar-tag { font-size: 12px; opacity: 0.7; letter-spacing: 0.08em; text-transform: uppercase; }

  /* ── Document card ── */
.msa-doc-card {
    width: 100%; max-width: 860px;
    background: #fff;
    box-shadow: 0 2px 20px rgba(0,0,0,0.12);
    margin: 0 auto;
}

  /* ── Document itself (captured for PDF) ── */
  #msa-doc {
    padding: 60px 72px;
    font-family: 'Libre Baskerville', serif;
    font-size: 10.5pt;
    line-height: 1.7;
    color: #111;
     width: 100%;
  max-width: 794px;
  margin: 0 auto;
  }

//   #msa-doc {
//   width: 100%;
//   max-width: 794px;
//   margin: 0 auto;
// }

  /* ── Notice banner ── */
  .msa-notice-box {
    border: 1px solid #bbb; padding: 12px 16px;
    margin-bottom: 28px; font-size: 9.5pt;
    font-style: italic; color: #222; text-align: center; line-height: 1.6;
  }

  /* ── Main title ── */
  .msa-doc-title {
    font-family: 'Libre Baskerville', serif;
    font-size: 16pt; font-weight: 700;
    text-align: center; margin-bottom: 22px;
    text-transform: uppercase; letter-spacing: 0.05em;
  }

  .msa-intro { margin-bottom: 18px; }

  /* ── Section headings ── */
  .msa-section-head {
    font-family: 'Libre Baskerville', serif;
    font-size: 11pt; font-weight: 700;
    margin-top: 28px; margin-bottom: 10px;
    text-transform: uppercase;
  }

  /* ── Body text ── */
//   .msa-para { margin-bottom: 10px; text-align: justify; }
.msa-para {
  margin-bottom: 10px;
  text-align: justify;
  text-justify: inter-word;
  word-spacing: normal;
}

  .msa-para strong { font-weight: 700; }

  /* Definition list */
  .msa-def { padding-left: 24px; margin-bottom: 8px; text-align: justify; }

  /* Sub-clauses */
  .msa-subclause { padding-left: 20px; margin-bottom: 8px; text-align: justify; }
  .msa-subclause-label { font-weight: 700; margin-right: 4px; }

  /* ── Signature table ── */
  .msa-sig-table { width: 100%; border-collapse: collapse; margin: 20px 0 10px; }
  .msa-sig-table td {
    width: 50%; vertical-align: top;
    padding: 10px 14px; border: 1px solid #bbb;
    font-size: 10pt; line-height: 1.7;
  }
  .msa-sig-field-label { font-weight: 700; display: block; margin-bottom: 2px; }
  .msa-sig-value { display: block; min-height: 20px; }
  .msa-sig-cursive {
    font-family: 'Libre Baskerville', serif; font-style: italic;
    font-size: 18pt; color: #1a3a5c; line-height: 1.2; min-height: 36px;
  }

  /* Schedule tables */
  .msa-schedule-table { width: 100%; border-collapse: collapse; margin: 10px 0 18px; font-size: 10pt; }
  .msa-schedule-table td, .msa-schedule-table th {
    border: 1px solid #bbb; padding: 7px 10px; vertical-align: top;
  }
  .msa-schedule-table th { background: #f0f0f0; font-weight: 700; }
  .msa-schedule-table .label-col { font-weight: 700; width: 40%; background: #fafafa; }

  /* ── Action bar (outside PDF area) ── */
  .msa-action-bar {
    display: flex; align-items: center; justify-content: space-between;
    padding: 18px 72px; border-top: 2px solid #e8e8e8;
    background: #fafafa; flex-wrap: wrap; gap: 12px;
  }
  .msa-action-hint { font-size: 12px; color: #888; }
  .msa-btn-open-modal {
    background: #1a3a5c; color: #fff; border: none;
    padding: 12px 32px; font-family: 'Source Sans 3', sans-serif;
    font-size: 14px; font-weight: 700; cursor: pointer;
    border-radius: 3px; letter-spacing: 0.03em; transition: background 0.15s;
  }
  .msa-btn-open-modal:hover { background: #0f2540; }

  /* ── Generating overlay ── */
  .msa-gen-overlay {
    position: fixed; inset: 0; background: rgba(255,255,255,0.88);
    display: flex; flex-direction: column; align-items: center;
    justify-content: center; z-index: 2000; gap: 16px;
  }
  .msa-gen-spinner {
    width: 44px; height: 44px; border: 4px solid #d0d8e0;
    border-top-color: #1a3a5c; border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
 @keyframes spin { to { transform: rotate(360deg); } }
  .msa-gen-text { font-size: 15px; color: #1a3a5c; font-weight: 600; }

  /* ── PDF page-break controls ── */
  #msa-doc p { orphans: 4; widows: 4; }
  .msa-section-head { page-break-before: auto; page-break-after: avoid; }
  .msa-para { page-break-inside: avoid; }
  .msa-def { page-break-inside: avoid; }
  .msa-sig-table { page-break-inside: avoid; }
  .msa-schedule-table { page-break-inside: avoid; }
  .msa-schedule-table tr { page-break-inside: avoid; page-break-after: auto; }
  .msa-notice-box { page-break-inside: avoid; }
`;

// ─── Helpers ───────────────────────────────────────────────────────────────
function today() {
    return new Date().toLocaleDateString("en-IN", { day: "2-digit", month: "long", year: "numeric" });
}

// ─── Modal: Collect authorized person details ──────────────────────────────
function AuthModal({ onAgree, onCancel }) {
    const [form, setForm] = useState({ name: "", designation: "", mobile: "", email: "" });
    const [errors, setErrors] = useState({});
    const [validEmail, setValidEmail] = useState(true);

    function change(field, val) {
        setForm(f => ({ ...f, [field]: val }));
        setErrors(e => ({ ...e, [field]: "" }));

        if (field === "email") {
            const emailPattern = /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
            if (emailPattern.test(val)) {
                axios.get(`/validate_email/${val}`)
                    .then((res) => {
                        setValidEmail(res.data);
                    })
                    .catch((error) => {
                        console.error("Error Validating Email:", error);
                    });
            } else {
                setValidEmail(true);
            }
        }
    }

    function validate() {
        const e = {};
        if (!form.name.trim()) e.name = "Full name is required";
        if (!form.designation.trim()) e.designation = "Designation is required";
        if (!form.mobile.trim()) e.mobile = "Mobile number is required";
        else if (!/^[1-9]{1}[0-9]{9}$/.test(form.mobile.trim())) e.mobile = "Enter a valid 10-digit mobile number";
        if (!form.email.trim()) e.email = "Email is required";
        else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email.trim())) e.email = "Enter a valid email address";
        if (!validEmail) e.email = "Invalid Domain";
        return e;
    }

    function handleAgree() {
        const e = validate();
        if (Object.keys(e).length) { setErrors(e); return; }
        onAgree(form);
    }

    return (
        <div className="msa-overlay">
            <div className="msa-modal">
                <div className="msa-modal-logo">Cappitall<span> Want</span> Network</div>
                <h2>Confirm Your Details</h2>
                <p className="msa-modal-sub">
                    Please enter the authorized signatory details. By clicking <strong>"I Agree"</strong>,
                    you confirm you have read and accept this Master Services Agreement in full.
                </p>

                <div className="msa-field">
                    <label>Full Name *</label>
                    <input
                        type="text" placeholder="e.g. Rajesh Kumar"
                        value={form.name}
                        onChange={e => {
                            const onlyAlpha = e.target.value.replace(/[^a-zA-Z\s]/g, '');
                            change("name", onlyAlpha.slice(0, 255));
                        }}
                        maxLength={200}
                        className={errors.name ? "error" : ""}
                    />
                    {errors.name && <div className="msa-field-error">{errors.name}</div>}
                </div>
                <div className="msa-field">
                    <label>Designation *</label>
                    <input
                        type="text" placeholder="e.g. Managing Partner"
                        value={form.designation}
                        onChange={e => change("designation", e.target.value.slice(0, 255))}
                        maxLength={200}
                        className={errors.designation ? "error" : ""}
                    />
                    {errors.designation && <div className="msa-field-error">{errors.designation}</div>}
                </div>
                <div className="msa-field">
                    <label>Mobile Number *</label>
                    <input
                        type="tel" placeholder="e.g. 9876543210"
                        value={form.mobile}
                        onChange={e => {
                            const onlyNums = e.target.value.replace(/[^0-9]/g, '');
                            change("mobile", onlyNums.slice(0, 10));
                        }}
                        className={errors.mobile ? "error" : ""}
                    />
                    {errors.mobile && <div className="msa-field-error">{errors.mobile}</div>}
                </div>
                <div className="msa-field">
                    <label>Email Address *</label>
                    <input
                        type="email" placeholder="e.g. rajesh@yourfirm.com"
                        value={form.email} onChange={e => change("email", e.target.value)}
                        className={errors.email ? "error" : ""}
                        onKeyPress={(e) => {
                            if (e.key === " ") e.preventDefault();
                        }}
                    />
                    {errors.email && <div className="msa-field-error">{errors.email}</div>}
                    {!validEmail && !errors.email && (
                        <div className="msa-field-error">Invalid Domain</div>
                    )}
                </div>

                <div className="msa-modal-actions">
                    <button className="msa-btn-cancel" onClick={onCancel}>Cancel</button>
                    <button className="msa-btn-agree" onClick={handleAgree}>✓ I Agree &amp; Download PDF</button>
                </div>
            </div>
        </div>
    );
}

// ─── Signature table row (used in 3 places) ────────────────────────────────
function SigTable({ clientName, clientDesignation, signedDate, entityName }) {
    return (
        <table className="msa-sig-table">
            <tbody>
                <tr>
                    <td>
                        <span className="msa-sig-field-label">FOR {entityName || "[COUNTERPARTY / CLIENT NAME]"} (Authorised Signatory)</span>
                    </td>
                    <td>
                        <span className="msa-sig-field-label">FOR CAPPITALL WANT SOLUTIONS PRIVATE LIMITED (Authorised Signatory)</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        {clientName
                            ? <span className="msa-sig-cursive">{clientName}</span>
                            : <span className="msa-sig-value" style={{ minHeight: 44 }}>&nbsp;</span>
                        }
                    </td>
                    <td>
                        <span className="msa-sig-cursive">Karthikeyan B</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span className="msa-sig-field-label">Name</span>
                        <span className="msa-sig-value">{clientName || " "}</span>
                    </td>
                    <td>
                        <span className="msa-sig-field-label">Name</span>
                        <span className="msa-sig-value">Karthikeyan B</span>
                    </td>
                </tr>
                <tr>
                    <td>
                        <span className="msa-sig-field-label">Designation</span>
                        <span className="msa-sig-value">{clientDesignation || " "}</span>
                    </td>
                    <td>
                        <span className="msa-sig-field-label">Designation</span>
                        <span className="msa-sig-value">Head - Product</span>
                    </td>
                </tr>
                {signedDate && (
                    <tr>
                        <td>
                            <span className="msa-sig-field-label">Date</span>
                            <span className="msa-sig-value">{signedDate}</span>
                        </td>
                        <td>
                            <span className="msa-sig-field-label">Date</span>
                            <span className="msa-sig-value">{signedDate}</span>
                        </td>
                    </tr>
                )}
            </tbody>
        </table>
    );
}

// ─── The full MSA document ─────────────────────────────────────────────────
function MSADocument({ person, signed, signedDate, docRef, businessType }) {
    return (
        <div id="msa-doc" ref={docRef}>

            {/* Notice banner */}

            <div className="msa-doc-title">Master Services Agreement</div>

            <div className="msa-notice-box">
                <em>By clicking 'I Agree', signing below, or otherwise accessing or using the Platform, you confirm that
                    you have read, understood, and agree to be legally bound by this Master Services Agreement in its
                    entirety, including all Schedules and the Standard Terms of Business annexed hereto.</em>
            </div>

            <p className="msa-para">
                <strong>THIS MASTER SERVICES AGREEMENT</strong> (hereinafter referred to as the <strong>"Agreement"</strong>) is
                entered into as of the Effective Date specified in Schedule A, by and between:
            </p>
            <p className="msa-para">
                <strong>Cappitall Want Solutions Private Limited</strong>, a company incorporated under the Companies Act, 2013,
                having its registered office at No. 930/913, C-106, Meenakshi Mangalam Apt., Near Mitra Academy, Arekere,
                B.G. Road, Bangalore, Karnataka – 560076, India; operating its technology platform under the brand name{" "}
                <strong>Cappitall Want Network (hereinafter referred to as "CWN");</strong> AND
            </p>
            <p className="msa-para">
                <strong>The Counterparty / Client / Subscriber</strong>, whose details are set out in Schedule A (hereinafter
                referred to as the 'Client', 'Counterparty', or 'Subscriber', as the context may require).
            </p>
            <p className="msa-para">
                CWN and the Client shall each be referred to individually as a 'Party' and collectively as the 'Parties'. This
                Agreement governs the entirety of the relationship between the Parties, including the disclosure of confidential
                information, the provision of platform services and subscriptions, and all related obligations and supersedes all
                prior letters, undertakings, proposals, and correspondence between the Parties in relation to its subject matter.
                Notwithstanding the foregoing, where either Party has a specific requirement that is not addressed or is
                inconsistent with the terms of this Agreement, such requirement may be accommodated through a separate Statement
                of Work, Addendum, or such other written instrument as the Parties may mutually agree upon in writing, duly
                executed by authorised representatives of both Parties, which shall be read as supplemental to and form an
                integral part of this Agreement.
            </p>

            {/* SECTION I */}
            <div className="msa-section-head">Section I – Definitions</div>
            <p className="msa-para">The following terms, when used in this Agreement (including the Schedules and Standard Terms), shall have the meanings ascribed to them below:</p>
            {[
                ['"Agreement"', 'means this Master Services Agreement, together with all Schedules, the Standard Terms of Business, and any other documents incorporated herein by reference, as may be amended in writing from time to time.'],
                ['"Authorised User"', "means any employee, officer, consultant, or representative of the Client who has been granted access to the Platform by the Client in accordance with this Agreement."],
                ['"Clickwrap Acceptance"', "means the act by which the Client or its Authorised User clicks 'I Agree', 'Accept', or any equivalent button or checkbox, or otherwise digitally affirms acceptance of this Agreement upon accessing the Platform or executing an onboarding flow, which shall constitute a legally binding acceptance of all terms herein."],
                ['"Commencement Date"', "means the date on which the Client executes this Agreement, completes Clickwrap Acceptance, or first accesses the Platform, whichever is the earliest."],
                ['"Confidential Information"', "means any and all information and data, whether written, oral, electronic, or in any other form, pertaining to the Disclosing Party that is of a confidential, proprietary, or commercially sensitive nature, including without limitation: (a) technical information such as source code, APIs, algorithms, software architecture, data models, and know-how; (b) business information such as pricing, financial data, customer lists, business strategies, and marketing plans; and (c) any information marked or communicated as 'Confidential' or 'Proprietary'. For the purposes of this Agreement, all information disclosed by CWN regarding its Platform, technology, and business model shall be deemed Confidential Information unless explicitly stated otherwise."],
                ['"DPA"', "means the Data Processing Agreement or the respective Privacy Policy between the Parties, which governs all obligations in connection with the processing of personal data under this Agreement."],
                ['"Effective Date"', "means the date specified as such in Schedule A, or if no such date is specified, the Commencement Date."],
                ['"Intellectual Property Rights"', "means all present and future rights in patents, copyrights, trademarks, trade secrets, database rights, design rights, moral rights, know-how, and all other intellectual property rights, whether registered or unregistered, in any jurisdiction."],
                ['"Platform"', "means the proprietary cloud-based software platform operated by CWN under the brand name 'Cappitall Want Network', through which CWN delivers its working capital optimisation and Governance, Risk & Compliance ('GRC') services, including all programs, tools, modules, reports, and functionalities made available therethrough."],
                ['"Purpose"', "means the evaluation of a potential or existing business relationship between the Parties, specifically including the Client's use of, or consideration of using, the Platform as a technology microservice or subscription service."],
                ['"Services"', "means the subscription services, platform access, modules, support, and related deliverables provided by CWN to the Client as described in Schedule B and any Proposal incorporated herein."],
                ['"Subscription Fee"', "means the fees payable by the Client as set out in Schedule B."],
                ['"Term"', "means the period commencing on the Effective Date and ending on the date of expiry or termination of this Agreement in accordance with Section VIII below."],
            ].map(([term, def]) => (
                <p key={term} className="msa-def"><strong>{term}</strong> {def}</p>
            ))}

            {/* SECTION II */}
            <div className="msa-section-head">Section II – Confidentiality and Non-Disclosure</div>
            <p className="msa-para"><strong>2.1</strong> The Parties recognize that in the course of their relationship under this Agreement, each Party (the 'Disclosing Party') may find it necessary to disclose Confidential Information to the other Party (the 'Receiving Party'). All Confidential Information disclosed by CWN including but not limited to its Platform architecture, source code, pricing models, proprietary methodologies, and business processes shall be treated as strictly confidential by the Client from the moment of first disclosure, whether or not it has been confirmed in writing.</p>
            <p className="msa-para"><strong>2.2</strong> The Receiving Party undertakes to: (a) hold all Confidential Information of the Disclosing Party in strict confidence and not disclose it to any third party without the prior written consent of the Disclosing Party; (b) use the Confidential Information exclusively for the Purpose and for no other purpose; (c) afford the Confidential Information of the Disclosing Party at least the same degree of protection as it applies to its own confidential information, and in no event less than a reasonable standard of care; (d) restrict access to the Confidential Information to those of its employees, officers, directors, advisors, or Authorised Users who have a strict need-to-know for the Purpose, and ensure that all such persons are bound by written obligations of confidentiality no less stringent than those contained herein; and (e) promptly notify the Disclosing Party in writing upon becoming aware of any actual or suspected unauthorised access to, disclosure of, or loss of any Confidential Information, and take all reasonable steps to mitigate the consequences thereof.</p>
            <p className="msa-para"><strong>2.3</strong> Where Confidential Information is disclosed orally, the Disclosing Party shall reduce such disclosure to writing within forty-eight (48) hours. The Receiving Party's obligations shall apply from the time of the oral disclosure, regardless of whether written confirmation is subsequently provided.</p>
            <p className="msa-para"><strong>2.4</strong> The obligations of confidentiality in this Section shall not apply to information that the Receiving Party can demonstrate, by clear and contemporaneous written evidence: (a) is or becomes part of the public domain through no act or omission of the Receiving Party; (b) was lawfully in the Receiving Party's possession, free of any obligation of confidence, at the time of disclosure; (c) was lawfully received from a third party with the unrestricted legal right to disclose it; (d) was independently developed by the Receiving Party's personnel without access to or use of the Confidential Information; or (e) is required to be disclosed pursuant to a valid order of a court or competent regulatory authority, provided that the Receiving Party gives the Disclosing Party prompt prior written notice and cooperates in seeking a protective order, disclosing only the minimum portion legally required.The burden of proving any such exclusion rests entirely upon the Receiving Party. </p>

            {/* SECTION III */}
            <div className="msa-section-head">Section III – Intellectual Property and Ownership</div>
            <p className="msa-para"><strong>3.1</strong> All Intellectual Property Rights in and to the Platform including without limitation its underlying technology architecture, source code, data models, algorithms, proprietary workflows, reports, and documentation vest exclusively in CWN and shall at all times remain the property of CWN. Nothing in this Agreement shall be construed to grant the Client any right, title, license, or interest, whether express or implied, in or to any Intellectual Property Rights of CWN.</p>
            <p className="msa-para"><strong>3.2</strong> The Client shall not, and shall ensure that its Authorized Users do not, directly or indirectly: reverse engineer, decompile, disassemble, replicate, copy, modify, adapt, create derivative works of, or otherwise attempt to derive or reconstruct CWN's technology, software, or proprietary business model, in whole or in part.</p>
            <p className="msa-para"><strong>3.3</strong> CWN retains ownership of all copyright and Intellectual Property Rights in all work products, reports, data outputs, and materials generated through or by the Platform, including those generated using data provided by the Client. The Client shall acquire the right to access and use such outputs in their tangible form, solely for its own internal business purposes, upon full payment of the applicable Subscription Fees.This right of use does not confer ownership of the Platform or any component thereof. </p>
            <p className="msa-para"><strong>3.4</strong> The Client grants CWN a limited, non-exclusive, royalty-free license to access, process, and use the Client's data solely to the extent necessary to provide the Services. CWN shall not use the Client's data for any purpose other than the provision of Services under this Agreement, except as required by law or as expressly permitted by the DPA.</p>
            <p className="msa-para"><strong>3.5</strong> CWN may, in its external communications, reference the fact that the Client has subscribed to or used the Platform, and may identify the Client by name or logo, without breaching any confidentiality obligation under this Agreement.</p>

            {/* SECTION IV */}
            <div className="msa-section-head">Section IV – Services and Platform Access</div>
            <p className="msa-para"><strong>4.1</strong> Subject to the terms of this Agreement and full payment of the applicable Subscription Fees, CWN shall provide the Client with access to the Platform and the Services described in Schedule B. CWN shall provide the Services with reasonable skill and care, and in accordance with the specifications set out in Schedule B and any applicable Proposal incorporated by reference.</p>
            <p className="msa-para"><strong>4.2</strong> CWN represents that it has the requisite knowledge, expertise, personnel, and resources necessary to operate and maintain the Platform, and holds all licenses and permits required to conduct its operations and deliver the Services.CWN shall resolve accessibility and functionality issues in accordance with the service levels agreed between the Parties.</p>
            <p className="msa-para"><strong>4.3</strong> The Client is solely responsible for: (a) obtaining and maintaining all hardware, software, and connectivity required to access the Platform; (b) the accuracy, completeness, and legality of all data it inputs into or transmits through the Platform; and (c) ensuring that its Authorized Users comply with all terms of this Agreement. CWN shall not independently verify the accuracy of information or documents provided by the Client for onboarding or ongoing use. </p>
            <p className="msa-para"><strong>4.4</strong> The Client acknowledges that certain features of the Platform — specifically PAN to TAN Fetching and 26AS Auto Download — attract separate per-use charges in addition to and independent of the Subscription Fee, whether during a trial period or a paid subscription.Accessing or using either feature constitutes the Client's acknowledgement and acceptance of the applicable per-use charges.</p>

            {/* SECTION V */}
            <div className="msa-section-head">Section V – Payment Obligations</div>
            <p className="msa-para"><strong>5.1</strong> The Client agrees to pay the Subscription Fees set out in Schedule B. All platform subscriptions are prepaid and payable in advance prior to the commencement of each subscription period or billing cycle, as applicable, and are non-refundable except as expressly provided herein or as required by applicable law.</p>
            <p className="msa-para"><strong>5.2</strong> All payments shall be made in Indian National Rupees (INR), via bank transfer, credit card, online payment gateway, or such other method as may be specified by CWN. The Client is solely responsible for all applicable taxes, including Goods and Services Tax (GST), in relation to the Subscription Fees, excluding taxes levied on CWN's income. CWN shall provide valid tax invoices in the format prescribed under applicable law.</p>
            <p className="msa-para"><strong>5.3</strong> In the event the Client disputes any invoice, it shall notify CWN in writing within fifteen (15) days of the invoice date, setting out the basis of the dispute in reasonable detail. The Parties shall endeavour to resolve the dispute in good faith within fifteen (15) days of such notice, Undisputed amounts shall remain payable by the original due date.</p>
            <p className="msa-para"><strong>5.4</strong> CWN shall notify the Client of the upcoming expiry of its subscription no later than seven (7) days prior to the expiry date. If the Client fails to renew or make payment by the due date, access to the Platform shall automatically stand suspended with immediate effect, without any requirement of further notice from CWN. Termination of access shall not entitle the Client to any refund or compensation.</p>

            {/* SECTION VI */}
            <div className="msa-section-head">Section VI – Subscription Term, Renewal, and Trial Periods</div>
            <p className="msa-para"><strong>6.1</strong> Subscription Term and Renewal. The subscription shall commence on the Effective Date and continue for the Term specified in Schedule A, unless earlier terminated in accordance with Section VIII. As of the date of this Agreement, the subscription does not auto-renew upon expiry of the Term, and the Client shall be required to expressly renew in writing  to continue access to the Platform. CWN reserves the right, at its sole discretion, to introduce auto-renewal and/or auto-payment functionality at any point in the future. In the event CWN elects to do so, CWN shall provide the Client with not less than thirty (30) days' prior written notice before any such auto-renewal or auto-payment mechanism takes effect in respect of the Client's subscription. The Client shall have the right, within such notice period, to opt out of auto-renewal by notifying CWN in writing. Continued use of the Platform after the effective date of any such change, without a timely written opt-out, shall be deemed to constitute the Client's acceptance of the updated renewal terms. CWN further reserves the right to modify its renewal and payment policies from time to time, subject always to providing the Client with reasonable prior written notice of any such change. </p>
            <p className="msa-para"><strong>6.2</strong> Upon expiry or non-renewal, CWN shall retain all Client data for ninety (90) days from the date of expiry, or such period as prescribed under CWN's data retention policy, whichever is applicable (the <strong>'Data Retention Period'</strong>), subject always to any longer retention period required under applicable law. Data export is available exclusively during an active, paid subscription period the Client may submit export requests only while its subscription remains current and all Subscription Fees are paid in full, and such right ceases immediately upon suspension, expiry, or termination. For the avoidance of doubt, CWN does not retain data generated during a trial period and shall have no obligation to export, provide access to, or make available any such data following expiry of the trial. Upon expiry of the Data Retention Period, CWN shall permanently delete all Client data without further liability. </p>
            <p className="msa-para"><strong>6.3</strong> Where CWN offers a trial period, such trial shall be for the duration expressly specified at the time of onboarding. Upon the expiry of the trial period, if the Client has not subscribed to a paid plan, access to the Platform and all associated features, data, outputs, and programs shall be automatically suspended without further notice. CWN shall have no obligation to retain data generated during the trial period following such suspension.</p>

            {/* SECTION VII */}
            <div className="msa-section-head">Section VII – Data Protection and Consent</div>
            <p className="msa-para"><strong>7.1 Client Warranties on Data.</strong> The Client warrants that it has obtained all necessary, informed, freely given, specific, and valid consents from its end clients, employees, customers, vendors, and all other data subjects whose personal data is provided to CWN under or in connection with this Agreement. The Client further warrants that such consents are obtained and maintained in full compliance with all applicable data protection and privacy laws, including without limitation: (a) the Digital Personal Data Protection Act, 2023, and any rules, regulations, or notifications issued thereunder ('DPDPA'); (b) the General Data Protection Regulation (EU) 2016/679 ('GDPR'), to the extent applicable to the processing of personal data of data subjects located in the European Economic Area; (c) the UK General Data Protection Regulation and the UK Data Protection Act, 2018, to the extent applicable; (d) any state, provincial, or sector-specific data protection or privacy legislation applicable to the Client's business or jurisdiction; and (e) any other applicable data protection, privacy, or cybersecurity law, regulation, or binding guidance issued by a competent regulatory authority in any jurisdiction in which the Client operates or from which personal data is sourced (collectively, 'Applicable Data Protection Laws'). The Client acknowledges and agrees that it is solely responsible for determining which Applicable Data Protection Laws apply to its operations and for ensuring full compliance therewith.</p>
            <p className="msa-para"><strong>7.2 Data Processing Agreement.</strong> The rights and obligations of the Parties in connection with the collection, storage, processing, transfer, and use of personal data are further governed by the specific data privacy laws in force of the competent jurisdiction and the internal privacy laws of the Parties, which forms an integral part of this Agreement. The DPA and this Section VII shall together govern all data processing obligations of the Parties. In the event of any conflict or inconsistency between the provisions of this Section and the privacy policy, the terms of the privacy shall prevail to the extent of such conflict. </p>
            <p className="msa-para"><strong>7.3 Indemnity for Data Protection Breaches.</strong> The Client shall indemnify, defend, and hold harmless CWN, its directors, officers, employees, consultants, and agents from and against any and all claims, demands, investigations, proceedings, damages, penalties, fines, losses, costs, and expenses (including reasonable legal fees) arising out of or in connection with: (a) the Client's failure to obtain valid, informed, and lawful consent from any data subject whose personal data is provided to CWN under this Agreement; (b) any breach by the Client of any Applicable Data Protection Law; (c) any misrepresentation by the Client regarding the lawfulness of any data provided to CWN; or (d) any third-party claim brought against CWN arising from the Client's acts or omissions in relation to the processing of personal data under this Agreement. This indemnity shall apply regardless of whether such claim arises under Indian law, EU/UK GDPR, or any other Applicable Data Protection Law, and shall survive the termination or expiry of this Agreement.</p>
            <p className="msa-para"><strong>7.4 CWN's Data Protection Obligations.</strong> CWN shall process all personal data received from the Client solely for the purposes set out in this Agreement and the privacy policy, and shall implement reasonable and appropriate technical and organizational measures to protect such data against unauthorized access, disclosure, alteration, or destruction. CWN shall comply with all Applicable Data Protection Laws to the extent they apply to CWN as a data processor or data fiduciary, as the case may be under the relevant law. CWN shall promptly notify the Client in writing upon becoming aware of any personal data breach affecting the Client's data, in accordance with the timelines prescribed under Applicable Data Protection Laws, and shall provide all reasonable cooperation and assistance to the Client in relation to such breach.</p>

            {/* SECTION VIII */}
            <div className="msa-section-head">Section VIII – Term and Termination</div>
            <p className="msa-para"><strong>8.1</strong> This Agreement shall come into effect on the Commencement Date and continue for the Term specified in Schedule A, unless earlier terminated in accordance with this Section.</p>
            <p className="msa-para"><strong>8.2 Termination for Cause.</strong> Either Party may terminate this Agreement with immediate effect by written notice if the other Party commits a material breach of this Agreement that is either incapable of remedy, or that the defaulting Party fails to remedy within fifteen (15) days of receiving written notice specifying the breach in reasonable detail.</p>
            <p className="msa-para"><strong>8.3 Termination for Convenience.</strong> Either Party may terminate this Agreement by providing thirty (30) days' prior written notice to the other Party, at any time after the expiry of three (3) months from the Effective Date. This clause applies only to paid subscription engagements and not to trial period access.</p>
            <p className="msa-para"><strong>8.4 Non-Payment and Non-Renewal.</strong> If the Client fails to make payment of the applicable Subscription Fee on or before the due date, or fails to renew its subscription upon expiry, this Agreement and all rights granted to the Client hereunder shall stand terminated with immediate effect, without any requirement of further notice.</p>
            <p className="msa-para"><strong>8.5 Accrued Charges on Termination.</strong> Termination of this Agreement for any reason shall not relieve the Client of the obligation to pay all fees, charges, and amounts due and payable to CWN as at the date of termination, including all per-use charges incurred prior to termination.</p>
            <p className="msa-para"><strong>8.6 Effect of Termination.</strong> Upon termination, the Client's access to the Platform shall be immediately suspended or revoked. CWN shall not be liable for any loss, damage, cost, or expense of any nature arising from such termination or the suspension of access.</p>
            <p className="msa-para"><strong>8.7 Survival.</strong> The following provisions shall survive termination or expiry of this Agreement: Section II (Confidentiality), Section III (Intellectual Property), Section V (Payment), Section IX (Limitations of Liability), Section X (Dispute Resolution), and any other provisions that by their nature are intended to survive.</p>

            {/* SECTION IX */}
            <div className="msa-section-head">Section IX – Representations, Warranties, and Liability</div>
            <p className="msa-para"><strong>9.1</strong> CWN represents and warrants that: (a) it is duly organized and validly existing under the laws of the Republic of India and has full authority to enter into and perform this Agreement; (b) the Platform will perform materially in accordance with its documentation; (c) CWN will implement reasonable technical and organizational safeguards for the protection of the Client's data; (d) CWN will not materially decrease the overall functionality of the Platform during the Term; and (e) the Platform and Services shall not infringe the Intellectual Property Rights of any third party.</p>
            <p className="msa-para"><strong>9.2</strong> The Client represents and warrants that it has the necessary legal capacity, powers, authorisations, consents, and approvals to validly and lawfully enter into and perform its obligations under this Agreement, and that the execution and performance of this Agreement do not and will not conflict with any applicable law, regulation, or existing obligation of the Client.</p>
            <p className="msa-para"><strong>9.3</strong> CWN shall indemnify the Client only against direct, documented losses solely attributable to CWN's material breach of this Agreement, finally adjudicated infringement of a third party's registered Intellectual Property Rights (excluding anything arising from the Client's data, instructions, or unauthorised use), proven breach of confidentiality or data protection obligations, or acts finally adjudicated as gross negligence or willful misconduct provided always that the Client notifies CWN in writing within thirty (30) days of becoming aware of the claim, grants CWN sole control of the defense, cooperates fully, and takes all reasonable steps to mitigate its loss. This indemnity does not cover indirect, consequential, or punitive losses, is subject to the cap in Clause 9.5, excludes any loss arising from the Client's own negligence, breach, or unauthorised use of the Platform, and constitutes the Client's sole remedy for the matters covered herein. </p>
            <p className="msa-para"><strong>9.4</strong> Neither Party shall be liable to the other in contract, tort, statute, or otherwise for any consequential, special, indirect, incidental, punitive, or exemplary damages, costs, expenses, or losses including without limitation, lost profits, loss of business, or opportunity costs arising from or in connection with this Agreement.</p>
            <p className="msa-para"><strong>9.5</strong> Subject to Clauses 9.3 and 9.4, each Party's maximum aggregate liability to the other for any direct loss or damage suffered, howsoever caused (including negligence, but excluding fraud or deliberate breach of duty), shall be limited to the total Subscription Fees actually paid by the Client to CWN under the current subscription Term.</p>

            {/* SECTION X */}
            <div className="msa-section-head">Section X – Non-Solicitation</div>
            <p className="msa-para">During the Term and for a period of twelve (12) months following the expiry or termination of this Agreement, neither Party shall, without the prior written consent of the other, directly or indirectly solicit, recruit, induce, or attempt to induce any employee, officer, or consultant of the other Party who was engaged in the performance of activities connected with this Agreement, to terminate their engagement with that Party or to enter into any employment or consulting arrangement with the soliciting Party or any of its affiliates.</p>

            {/* SECTION XI */}
            <div className="msa-section-head">Section XI – Force Majeure</div>
            <p className="msa-para">Neither Party shall be in breach of their contractual obligations, nor incur any liability to the other, to the extent that such Party is unable to comply with its obligations as a result of any cause beyond its reasonable control including without limitation acts of God, pandemics, governmental actions, civil disturbance, war, power failures, or internet outages. The affected Party shall notify the other Party in writing as soon as reasonably practicable of such an event, whereupon the non-affected Party shall have the option to suspend or terminate the Agreement by written notice.</p>

            {/* SECTION XII */}
            <div className="msa-section-head">Section XII – Dispute Resolution and Governing Law</div>
            <p className="msa-para"><strong>12.1</strong> This Agreement shall be governed by and construed in accordance with the laws of the Republic of India. Any disputes arising from or in connection with this Agreement shall, subject to the escalation procedure below, be subject to the exclusive jurisdiction of the courts of Bangalore, Karnataka, India.</p>
            <p className="msa-para"><strong>12.2</strong> In the event of any dispute, controversy, or claim arising out of or in connection with this Agreement, the Parties shall first endeavor to resolve the matter amicably through good faith negotiations at the senior management level, for a period of thirty (30) days from the date of written notice of the dispute.</p>
            <p className="msa-para"><strong>12.3</strong> If no resolution is achieved within thirty (30) days, the dispute shall be referred to Private Mediation under the Bangalore International Mediation, Arbitration & Conciliation Centre ('BIMACC') Rules, by appointing a BIMACC-Approved Mediator. The Parties shall endeavor to resolve the dispute through mediation within sixty (60) days from the date of the first mediation hearing.</p>
            <p className="msa-para"><strong>12.4</strong> If no settlement is reached within such sixty (60) day period, the dispute shall be referred to and finally resolved by Institutional Arbitration before a sole Arbitrator appointed by BIMACC, in accordance with the BIMACC Rules of Arbitration and the Arbitration and Conciliation Act, 1996 (as amended). The arbitration proceedings shall be held in Bangalore, conducted in the English language, and the arbitral award shall be final and binding on the Parties. Each Party shall bear its own costs of the proceedings unless the arbitral award provides otherwise.</p>

            {/* SECTION XIII */}
            <div className="msa-section-head">Section XIII – Clickwrap and Electronic Acceptance</div>
            <p className="msa-para"><strong>13.1</strong> This Agreement may be accepted and executed through Clickwrap Acceptance, that is, by clicking 'I Agree', 'Accept', or any equivalent button or checkbox, or by otherwise digitally affirming acceptance of this Agreement at the point of platform access or onboarding. The Client acknowledges and agrees that such Clickwrap Acceptance constitutes a legally binding acceptance of all terms of this Agreement, with the same legal force and effect as a handwritten signature.</p>
            <p className="msa-para"><strong>13.2</strong> For the avoidance of doubt, Clickwrap Acceptance as described in Clause 13.1 is sufficient to constitute a valid and legally binding execution of this Agreement. Signatures whether wet-ink, PDF, DocuSign, SpotDraft, or any equivalent electronic form shall only be obtained if and to the extent specifically required, and where obtained, shall carry the same legal effect as original wet-ink signatures in accordance with applicable law in India.</p>
            <p className="msa-para"><strong>13.3</strong> The Client's continued access to or use of the Platform following any update to this Agreement (communicated by CWN via email or platform notification) shall constitute acceptance of the updated terms.</p>

            {/* SECTION XIV */}
            <div className="msa-section-head">Section XIV – General Provisions</div>
            <p className="msa-para"><strong>14.1 Entire Agreement.</strong> This Agreement, together with all Schedules, the Standard Terms of Business, and the privacy policy (where applicable), constitutes the entire agreement between the Parties with respect to its subject matter, and supersedes all prior negotiations, proposals, representations, understandings, and agreements, whether oral or written.</p>
            <p className="msa-para"><strong>14.2 Amendments.</strong> No amendment, modification, or waiver of any provision of this Agreement shall be valid or binding unless made in writing and duly executed by authorised representatives of both Parties. Verbal agreements shall not constitute amendments.</p>
            <p className="msa-para"><strong>14.3 Waiver.</strong> The failure of either Party to exercise or enforce any right under this Agreement shall not constitute a waiver of that right, nor prejudice such Party's ability to enforce it at any subsequent time.</p>
            <p className="msa-para"><strong>14.4 Severability.</strong> If any provision of this Agreement is found by a court of competent jurisdiction to be invalid, illegal, or unenforceable, it shall be deemed modified to the minimum extent necessary to make it valid and enforceable. The remaining provisions shall continue in full force and effect.</p>
            <p className="msa-para"><strong>14.5 Assignment.</strong> Neither Party shall assign, transfer, or sub-contract its rights or obligations under this Agreement without the prior written consent of the other Party, except that the Client may assign this Agreement in connection with a merger or to any affiliate of the Client without consent, upon written notice to CWN.</p>
            <p className="msa-para"><strong>14.6 Third Party Rights.</strong> This Agreement does not confer, and is not intended to confer, any rights on any third party. No third party shall have any right to enforce any provision of this Agreement.</p>
            <p className="msa-para"><strong>14.7 Conflicts of Interest.</strong> CWN shall implement all reasonable information barriers to protect each client's interests, including operational separation and separate data controls. The effective operation of such barriers shall constitute sufficient steps to discharge CWN's duty of confidentiality to the Client.</p>
            <p className="msa-para"><strong>14.8 Notices.</strong> All notices under this Agreement shall be in writing, in English, and delivered by: (a) email (with delivery confirmed by read receipt or written acknowledgment); (b) certified mail or courier; or (c) hand delivery to the addresses specified in Schedule A. A notice shall be deemed received on the date of transmission (for email) or on the date of physical delivery.</p>

            {/* IN WITNESS WHEREOF */}
            <div className="msa-section-head">In Witness Whereof</div>
            <p className="msa-para">The Parties have caused this Agreement to be executed by their respective duly authorized representatives as of the Effective Date.</p>
            <SigTable
                clientName={signed ? person.name : null}
                clientDesignation={signed ? person.designation : null}
                signedDate={signed ? signedDate : null}
                entityName={signed ? null : null}
            />

            {/* SCHEDULE A */}
            <div className="msa-section-head">Schedule A – Party Details &amp; Agreement Dates</div>

            <p className="msa-para"><strong>Section A1 – Cappitall Want Solutions Private Limited</strong></p>
            <table className="msa-schedule-table">
                <tbody>
                    {[
                        ["Full Legal Name", "Cappitall Want Solutions Private Limited / Cappitall Want Network"],
                        ["CIN", "U74999KA2020PTC140332"],
                        ["PAN", "AAJCC0788K"],
                        ["Registered Office", "No. 930/913, C-106, Meenakshi Mangalam Apt., Near Mitra Academy, Arekere, B.G. Road, Bangalore, Karnataka – 560076, India"],
                        ["Corporate Office", "#931, Bhavani Sadana, 1st Floor, BTM 4th Stage, 1st Sector, 4th Main Road, Bengaluru, KA – 560076"],
                        ["Authorised Signatory", "Karthikeyan B"],
                        ["Designation", "Head - Product"],
                        ["Email (for notices)", "compliance@cappitallwant.com"],
                        ["Website", "cappitallwant.com"],
                    ].map(([l, v]) => (
                        <tr key={l}><td className="label-col">{l}</td><td>{v}</td></tr>
                    ))}
                </tbody>
            </table>

            <p className="msa-para"><strong>Section A2 – Client / Counterparty Details</strong></p>
            <table className="msa-schedule-table">
                <tbody>

                    {[
                        ["Full Legal Name / Firm Name", localStorage.getItem("msa_entity_name") || ""],
                        ["Type of Entity", localStorage.getItem("msa_constitution") || ""],
                        ["CIN / Registration No.", localStorage.getItem("msa_cin") || ""],
                        ["PAN", localStorage.getItem("msa_pan") || ""],
                        ["Registered / Office Address", localStorage.getItem("msa_address") || ""],
                        ["State & Country", "India"],
                        ["Nature of Business", localStorage.getItem("msa_business_sector") || ""],
                        ["Authorised Signatory Name", signed ? person.name : ""],
                        ["Designation of Signatory", signed ? person.designation : ""],
                        ["Contact Email", signed ? person.email : ""],
                        ["Contact Phone / Mobile", signed ? person.mobile : ""],
                    ].map(([l, v]) => (
                        <tr key={l}><td className="label-col">{l}</td><td>{v}</td></tr>
                    ))}
                </tbody>
            </table>

            <p className="msa-para"><strong>Section A3 – Agreement Dates</strong></p>
            <table className="msa-schedule-table">
                <tbody>
                    {[
                        ["Commencement Date", signed ? signedDate : ""],
                        ["Effective Date", signed ? signedDate : ""],
                        ["Subscription Term", "One (1) year from the Effective Date, unless earlier terminated or renewed"],
                        ["Expiry Date (NDA)", "Two (2) years post-termination for confidentiality obligations"],
                        ["Onboarding Date", signed ? signedDate : ""],
                    ].map(([l, v]) => (
                        <tr key={l}><td className="label-col">{l}</td><td>{v}</td></tr>
                    ))}
                </tbody>
            </table>

            <p className="msa-para"><strong>Signatures to Schedule A</strong></p>
            <SigTable
                clientName={signed ? person.name : null}
                clientDesignation={signed ? person.designation : null}
                signedDate={signed ? signedDate : null}
            />

            {/* SCHEDULE B */}
            <div className="msa-section-head">Schedule B – Subscription Plan &amp; Pricing</div>

            <p className="msa-para"><strong>Section B1 – Subscribed Modules</strong></p>
            <table className="msa-schedule-table">
                <thead>
                    <tr>
                        <th>Module / Service</th>
                        <th>Annual Fee (excl. GST)</th>
                        <th>Payment Frequency</th>
                    </tr>
                </thead>
                <tbody>
                    {businessType === "SME" ? (
                        <>
                            <tr><td>26AS Subscription</td><td>₹ 72,000</td><td>Payable upfront</td></tr>
                            <tr><td>One-Time Setup (Including ERP Connector)</td><td>₹ 20,000</td><td>Payable upfront</td></tr>
                            <tr><td>Previous Year Data – FY24-25 &amp; prior (optional)</td><td>₹ 10,000</td><td>Based on usage</td></tr>
                            <tr><td>PAN to TAN Fetching (optional)</td><td>₹ 5.50 per fetch</td><td>Based on usage</td></tr>
                            <tr><td>26AS Form Auto Download (optional)</td><td>₹ 20 per download</td><td>Based on usage</td></tr>
                        </>
                    ) : (
                        <>
                            <tr><td>26AS Subscription</td><td>₹ 30,000</td><td>Payable upfront</td></tr>
                            <tr><td>One-Time Setup (Including ERP Connector)</td><td>₹ 20,000</td><td>Payable upfront</td></tr>
                            <tr><td>Previous Year Data – FY24-25 &amp; prior (optional)</td><td>₹ 10,000</td><td>Based on usage</td></tr>
                            <tr><td>PAN to TAN Fetching (optional)</td><td>₹ 5.50 per fetch</td><td>Based on usage</td></tr>
                            <tr><td>26AS Form Auto Download (optional)</td><td>₹ 20 per download</td><td>Based on usage</td></tr>
                        </>
                    )}
                </tbody>
            </table>
            <p className="msa-para" style={{ fontSize: "9.5pt", fontStyle: "italic" }}>
                Note: All amounts are exclusive of applicable taxes (GST levied at 18%). All fees are payable in advance per the payment frequency specified above.
            </p>

            <p className="msa-para"><strong>Section B2 – Inclusions in Package</strong></p>
            <table className="msa-schedule-table">
                <thead>
                    <tr><th>Parameter</th><th>Quantity / Scope</th></tr>
                </thead>
                <tbody>
                    {businessType === "SME" ? (
                        <>
                            <tr><td>Total number of PANs / Entities</td><td>1</td></tr>
                            <tr><td>Total number of yearly transactions</td><td>Unlimited</td></tr>
                            <tr><td>Total number of User IDs</td><td>Unlimited</td></tr>
                        </>
                    ) : (
                        <>
                            <tr><td>Total number of PANs / Entities</td><td>Unlimited</td></tr>
                            <tr><td>Total number of yearly transactions</td><td>30,000</td></tr>
                            <tr><td>Total number of User IDs</td><td>Unlimited</td></tr>
                        </>
                    )}
                </tbody>
            </table>

            <p className="msa-para"><strong>Signatures to Schedule B</strong></p>
            <SigTable
                clientName={signed ? person.name : null}
                clientDesignation={signed ? person.designation : null}
                signedDate={signed ? signedDate : null}
            />
            <p className="msa-para" style={{ fontSize: "9.5pt", fontStyle: "italic" }}>
                This Schedule B forms an integral part of the Master Services Agreement between the Parties.
            </p>

        </div>
    );
}

// ─── Root component ────────────────────────────────────────────────────────
export default function MSAWithPDF({ onPDFDownloaded, onPDFGenerated }) {
    const [showModal, setShowModal] = useState(false);
    const [person, setPerson] = useState(null);
    const [signed, setSigned] = useState(false);
    const [signedDate, setSignedDate] = useState("");
    const [generating, setGenerating] = useState(false);
    const [businessType, setBusinessType] = useState(
        () => localStorage.getItem("business_type") || "Multi Client Firm"
    );
    const docRef = useRef(null);

    async function handleAgree(formData) {
        setShowModal(false);
        setPerson(formData);
        setSigned(true);
        setSignedDate(today());
        const bType = localStorage.getItem("business_type") || "Multi Client Firm";
        console.log("----------------->", bType);
        setBusinessType(bType);

        // Small delay to let React re-render with signed content before capture
        setTimeout(() => generatePDF(formData), 500);
    }

    async function generatePDF(formData) {
        setGenerating(true);
        try {

            // Wait for fonts to load
            if (document.fonts && document.fonts.ready) {
                await document.fonts.ready;
            }

            // Load html2pdf if not loaded
            if (!window.html2pdf) {
                await new Promise((resolve, reject) => {
                    const s = document.createElement("script");
                    s.src = "https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js";
                    s.onload = resolve;
                    s.onerror = reject;
                    document.head.appendChild(s);
                });
            }

            const filename = `MSA_CWN_${formData.name.replace(/\s+/g, "_")}_${new Date().toISOString().split("T")[0]}.pdf`;

            // Create pdf instance
            const pdf = window.html2pdf().set({
                margin: [15, 12, 15, 12],
                filename,
                image: { type: "jpeg", quality: 0.98 },
                html2canvas: {
                    scale: 2,
                    useCORS: true,
                    letterRendering: true,
                    logging: false,
                    scrollY: -window.scrollY
                },
                jsPDF: { unit: "mm", format: "a4", orientation: "portrait" },
                pagebreak: {
                    mode: ["avoid-all", "css", "legacy"]
                }
            }).from(docRef.current);

            // Generate blob
            const pdfBlob = await pdf.outputPdf("blob");

            // Convert blob → base64
            const base64 = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result.split(",")[1]);
                reader.readAsDataURL(pdfBlob);
            });

            // Download the PDF
            await pdf.save();

            // Send data to parent
            if (onPDFGenerated) {
                onPDFGenerated({
                    base64,
                    name: formData.name,
                    designation: formData.designation,
                    email: formData.email,
                    mobile: formData.mobile
                });
            }

        } catch (err) {
            alert("PDF generation failed. Please try again.\n" + err.message);
            console.error(err);
        } finally {
            setGenerating(false);
            if (onPDFDownloaded) onPDFDownloaded();
        }
    }

    return (
        <>
            <style>{css}</style>

            {generating && (
                <div className="msa-gen-overlay">
                    <div className="msa-gen-spinner" />
                    <div className="msa-gen-text">Generating your signed PDF…</div>
                </div>
            )}

            {showModal && (
                <AuthModal
                    onAgree={handleAgree}
                    onCancel={() => setShowModal(false)}
                />
            )}

            <div className="msa-page">
                {/* Top bar */}
                <div className="msa-topbar">
                    <div className="msa-topbar-brand">Cappitall<span> Want</span> Network</div>
                    <div className="msa-topbar-tag">Master Services Agreement</div>
                </div>

                <div className="msa-doc-card">
                    {/* The document — this is what gets captured as PDF */}
                    <MSADocument
                        person={person || {}}
                        signed={signed}
                        signedDate={signedDate}
                        docRef={docRef}
                        businessType={businessType}
                    />

                    {/* Action bar — outside #msa-doc so it won't appear in PDF */}
                    <div className="msa-action-bar">
                        <div className="msa-action-hint">
                            {signed
                                ? `✓ Signed by ${person.name} on ${signedDate}`
                                : "Please read the agreement above before proceeding."}
                        </div>
                        <div style={{ display: "flex", gap: "10px" }}>
                            <button
                                className="msa-btn-cancel"
                                onClick={() => window.history.back()}
                            >
                                Cancel
                            </button>
                            <button
                                className="msa-btn-open-modal"
                                onClick={() => setShowModal(true)}
                            >
                                {signed ? "↓ Download PDF Again" : "I Agree →"}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
